import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { MessageBanner } from '@folio/stripes/components';
import { useRecordOpenErrorReports } from '../../hooks/useErrorReports';
var ERROR_REPORTS_PATH = '/czna-authorities/error-reports';
/**
 * CZNA-1596 — the record has a public error report that is still open (New or In progress).
 *
 * <p>Shown to everyone who sees the record (NK, 31. 10. 2026), so nobody works on a record
 * without knowing somebody reported it — but with a count only: the e-mail and the description
 * stay with the NK supervisor of the record's type and the authority administrator, who alone
 * get the link into the reports (canOpen, decided by the backend). The list opens on
 * every status, so a report already being handled is not hidden behind the "New" default.
 * Renders nothing when no report is open, so the banner goes with the last one closed.
 */
var OpenErrorReportsBanner = function (_a) {
    var recordId = _a.recordId;
    var _b = useRecordOpenErrorReports(recordId), openCount = _b.openCount, canOpen = _b.canOpen;
    if (openCount <= 0)
        return null;
    return (React.createElement(MessageBanner, { type: "warning" },
        React.createElement("div", { "data-testid": "record-open-error-reports" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.errorReports.recordBanner.title", values: { count: openCount } }),
            canOpen && (React.createElement(React.Fragment, null,
                ' ',
                React.createElement(Link, { to: "".concat(ERROR_REPORTS_PATH, "?status=ALL&recordId=").concat(encodeURIComponent(recordId)) },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.errorReports.recordBanner.open" })))))));
};
export default OpenErrorReportsBanner;
